import type { NextPage } from 'next';
import React, { useRef } from "react";
import { useSelectSlice } from "@common/redux/selectors/useSelectSlice";
import { movieSlice } from "@common/redux/slices/movies.slice";
import { recommendationSlice } from "@common/redux/slices/recommendation.slice";
import { ContentBlock } from '@kursk/components/ui/ContentBlock/ContentBlock';
import { Layout } from '@kursk/components/Layout/Layout';
import { Tags } from "@kursk/components/ui/Tags/Tags";
import { Socials } from "@kursk/components/pages/Home/Socials/Socials";
import { HeaderBlock } from "@kursk/components/ui/HeaderBlock/HeaderBlock";
import { SocialLinks } from "@kursk/components/ui/SocialLinks/SocialLinks";
import { SubscribeFooterForm } from "@kursk/components/ui/SubscribeFooterForm/SubscribeFooterForm";
import { RecommendationsBlock } from "@kursk/components/ui/RecommendationsBlock/RecommendationsBlock";
import { MovieSchedule } from "@kursk/components/pages/SingleMovie/MovieSchedule/MovieSchedule";
import { MovieHeaderButton } from "@kursk/components/pages/SingleMovie/MovieHeaderButton/MovieHeaderButton";
import styles from './SingleMovie.module.scss';
import { SeoMetaTitles } from "@kursk/components/seo/SeoMetaTitles";

export const SingleMovie: NextPage = () => {
  const { movie } = useSelectSlice(movieSlice);
  const { forMoviesMovies } = useSelectSlice(recommendationSlice);
  const scheduleTable = useRef(null);

  const onMovieHeaderButtonClick = () => {
    scheduleTable.current.scrollIntoView({ behavior: 'smooth' });
  }

  if (!movie) {
    return <></>;
  }
  return (
    <Layout key={`movie_${movie._id}`}>
      <SeoMetaTitles page="singleMovie" entity={movie}/>
      <div className={styles.movie}>
        <section>
          <HeaderBlock
            entityType={'movies'}
            entity={movie}
            goBack={'/movies'}
            goBackTitle={'вернуться к списку кино'}
            customCategoryName={'кино'}
            customBreadCrumb={{ title: 'кино', link: '/movies' }}
            customBuyButton={<MovieHeaderButton movie={movie} onClick={onMovieHeaderButtonClick}/>}
            firstBreadCrumbLink={'/events'}/>
        </section>
        <section className={styles.movie_social}>
          <SocialLinks/>
        </section>
        <section className={styles.movie_content}>
          <ContentBlock content={movie?.content} source={movie.source}/>
        </section>
        <section className={styles.movie_schedule} ref={scheduleTable}>
          <MovieSchedule movie={movie}/>
        </section>
        {movie?.genres?.length > 0 && (
          <section className={styles.movie_tags}>
            <Tags link={'/movies'} isGenre className={styles.movieTags} tags={movie?.genres}/>
          </section>
        )}
        <section className={styles.movie_subscribeForm}>
          <SubscribeFooterForm/>
        </section>
        <section className={styles.movie_recommendations}>
          <RecommendationsBlock
            entityType="movies"
            data={forMoviesMovies}
            title={'Рекомендуем посмотреть'}
            goTo={'/movies'}
            goToTitle={'все кино'}/>
        </section>
        <section className={styles.movie_social}>
          <Socials/>
        </section>
      </div>
    </Layout>
  )
}
